export default {
  data() {
    return {
      basemaps: {
        osm: {
          id: "Mtile Gram",
          url: "https://mtile.gram.tj/styles/basic-preview/{z}/{x}/{y}.png",
          options: { maxZoom: 19 },
        },
        google: {
          id: "Google",
          url: "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
          options: { maxZoom: 19 },
        },
        googleEarth: {
          id: "Google Earth",
          url: "https://mt2.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
          options: { maxZoom: 19 },
        },
        yandex: {
          id: "Yandex",
          url: "https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=4.19.4&x={x}&y={y}&z={z}&scale=1&lang=ru_RU",
          options: { maxZoom: 19 },
        },
        yandexHybrid: {
          id: "Yandex Hybrid",
          url: "https://core-sat.maps.yandex.net/tiles?l=sat&v=3.227.0.4&x={x}&y={y}&z={z}&scale=1&lang=ru_RU",
          options: { maxZoom: 19 },
        },
      },
    };
  },
  computed: {
    baseUrl() {
      return this.basemaps[this.currentBase].url;
    },
    baseOptions() {
      return this.basemaps[this.currentBase].options;
    },
  },
};
